import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
    typography: {
        useNextVariants: true, //Used to prevent typography migration error from material-ui (https://material-ui.com/style/typography#migration-to-typography-v2)
        fontFamily: "Source Sans Pro"
    },
    palette: {
        type: "dark",
        primary: {
            50: "#e2f5fc",
            100: "#b8e5f6",
            200: "#88d4f1",
            300: "#58c3eb",
            400: "#35b6e6",
            500: "#11a9e2",
            600: "#0fa2df",
            700: "#0c98da",
            800: "#0a8fd6",
            900: "#057ecf",
            A100: "#f7fcff",
            A200: "#c4e5ff",
            A400: "#91cfff",
            A700: "#78c3ff",
            contrastDefaultColor: "dark"
        },
        secondary: {
            50: "#fafbfc",
            100: "#f4f6f7",
            200: "#ecf0f1",
            300: "#e4eaeb",
            400: "#dfe6e7",
            500: "#d9e1e3",
            600: "#d5dde0",
            700: "#cfd9dc",
            800: "#cad5d8",
            900: "#c0cdd0",
            A100: "#ffffff",
            A200: "#ffffff",
            A400: "#ffffff",
            A700: "#ffffff",
            contrastDefaultColor: "dark"
        },
        grey: {
            50: "#e6e6e6",
            100: "#c2c2c2",
            200: "#999999",
            300: "#707070",
            400: "#515151",
            500: "#323232",
            600: "#2d2d2d",
            700: "#282828",
            800: "#1f1f1f",
            900: "#131313",
            contrastDefaultColor: "light"
        }
    },
    overrides: {
        MuiModal: {
            root: {
                zIndex: 99999
            }
        },
        MuiInput: {
            underline: {
                "&:before": {
                    borderBottom: "solid 1px rgba(255,255,255,0.15)"
                }
            }
            // adornedStart: {
            //     borderBottom: "solid 1px rgba(255,255,255,0.3)"
            // }
        },
        MuiTab: {
            root: {
                background: "transparent",
                height: 30
            },
            textColorInherit: {
                color: "white",
                height: 20
            }

        },
        MuiOutlinedInput: {
            root: {
                backgroundColor: "#fff",
                fontFamily: "inherit"
            },
            notchedOutline: {
                borderRadius: 0
            },
            input: {
                padding: "2px 10px !important",
                fontSize: "0.825em !important",
                color: "#333 !important",
                margin: "5px 0 !important",
                fontWeight: 500,
                fontFamily: "inherit"
            },
            adornedEnd: {
                paddingRight: 2
            }
        },
        MuiSelectOutlined: {
            root: {
                backgroundColor: "#fff",
                fontFamily: "inherit"
            },
            notchedOutline: {
                borderRadius: 0
            },
            input: {
                padding: "2px 10px !important",
                fontSize: "0.825em !important",
                color: "#333 !important",
                margin: "5px 0 !important",
                fontWeight: 500,
                fontFamily: "inherit"
            }
        },
        MuiCheckbox: {
            label: {
                fontWeight: 600
            }
        },
        MuiSnackbarContent: {
            root: {
                backgroundColor: "#333"
            },
            message: {
                color: "white",
                fontWeight: 600
            }
        },
        MuiButton: {
            root: {
                borderRadius: 0,
                color: "white",
                fontWeight: 600,
                letterSpacing: "0.05em",
                padding: "10px 25px"
            },
            contained: {
                boxShadow: "none",
                background: "white",
                color: "#333"
            },
            containedPrimary: {
                color: "white"
            },
            label: {
                display: "grid",
                gridAutoFlow: "column",
                columnGap: 10
            },
            textPrimary: {
                color: "white",
                i: {
                    color: "white"
                }
            },
            sizeSmall: {
                fontSize: 11,
                padding: "6px 12px"
            },
            sizeLarge: {
                fontSize: 16
            }
        },
        MuiTooltip: {
            tooltip: {
                padding: 10,
                fontSize: 12
            }
        },
        MuiDialog: {
            paper: {
                position: "inherit"
            }
        },
        MuiDialogContentText: {
            root: {
                // p: {
                //     marginBottom: 10
                // }
            }
        },
        MuiMenu: {
            paper: {
                background: "white",
                borderRadius: 0
            }
        },
        MuiMenuItem: {
            root: {
                color: "#333",
                fontFamily: "Source Sans Pro",
                fontSize: 14,
                fontWeight: 600,
                // textTransform: "uppercase",
                "&:hover": {
                    backgroundColor: "#11a9ef",
                    color: "white"
                },
                "&$selected": {
                    color: "#333",
                    backgroundColor: "#11a9ef",
                    "&:hover": {
                        backgroundColor: "#11a9ef !important",
                        color: "white"
                    }
                }
            },
        },
        MuiSelect: {
            icon: {
                fill: "#aaa"
            }
        },
        MuiList: {
            root: {
                fontSize: 14
            },
            padding: {
                paddingTop: 0,
                paddingBottom: 0
            }
        },
        MuiListItem: {
            root: {
                fontFamily: "inherit !important"
            },
            divider: {
                borderBottomColor: "rgba(0,0,0,.12)"
            }
        },
        MuiPopover: {
            paper: {
                backgroundColor: "#fff"
            }
        },
        MuiInputAdornment: {
            root: {
                color: "#333"
            }
        },
        MuiSwitch: {
            switchBase: {
                height: 32
            }
        }
    }
});

export default theme;

export const dialogTheme = createMuiTheme({
    typography: {
        useNextVariants: true, //Used to prevent typography migration error from material-ui (https://material-ui.com/style/typography#migration-to-typography-v2)
        fontFamily: "Source Sans Pro",
        h2: {
            fontSize: 40
        },
        h6: {
            fontSize: 24,
            fontWeight: 600,
            lineHeight: 1.2
            // color: "#11a9e2"
        }
    },
    palette: {
        type: "light",
        primary: {
            main: "#11a9e2"
        },
        secondary: {
            main: "#777"
        }
    },
    overrides: {
        MuiDialog: {
            paper: {
                borderRadius: 0,
                borderTop: "solid 6px #11a9e2",
                // padding: 20,
            }
        },
        MuiDialogContentText: {
            root: {
                color: "rgba(0,0,0,.75)"
            }
        },
        MuiDialogActions: {
            root: {
                margin: "8px 12px 12px"
            }
        },
        MuiMenu: {
            paper: {
                background: "white",
                borderRadius: 0
            }
        },
        MuiMenuItem: {
            root: {
                color: "#333",
                fontFamily: "Source Sans Pro",
                fontSize: 14,
                fontWeight: 600,
                // textTransform: "uppercase",
                "&:hover": {
                    backgroundColor: "#50bbe6",
                    color: "white"
                },
                ".selected": {
                    backgroundColor: "red"
                },
                "&$selected": {
                    color: "#50bbe6",
                    backgroundColor: "white !important",
                    "&:hover": {
                        backgroundColor: "#50bbe6 !important",
                        color: "white"
                    }
                }
            },
        },
        MuiSelect: {
            select: {
                color: "#333",
                fontSize: 14,
                fontWeight: 600,
                textTransform: "uppercase",
                borderRadius: 0,
                border: "solid 1px #aaa",
                padding: "8px 25px 8px 12px"
            }
        },
        MuiButton: {
            root: {
                borderRadius: 0
            },
            text: {
                fontWeight: 500
            },
            label: {
                fontWeight: 600,
                letterSpacing: 0.5,
                display: "grid",
                gridAutoFlow: "column",
                columnGap: 10
            },
            contained: {
                boxShadow: "none"
            },
            containedPrimary: {
                color: "white"
            }
        },
        MuiInput: {
            underline: {
                "&:before": {
                    borderBottom: "solid 1px #ccc",
                    borderBottomWidth: "1px !important"
                },
                "&:after": {
                    borderBottom: "solid 1px #11a9e2"
                }
            }
            // adornedStart: {
            //     borderBottom: "#11a9e2"
            // }
        },
        MuiList: {
            padding: {
                paddingTop: 0,
                paddingBottom: 0
            }
        },
        MuiListItem: {
            root: {
                "&$disabled": {
                    display: "none",
                    background: "white !important",
                    color: "rgba(0,0,0,.3) !important"
                },
                "&$selected": {
                    background: "red"
                },
            },
            divider: {
                borderBottomColor: "rgba(0,0,0,.12)"
            }
        },
        MuiOutlinedInput: {
            notchedOutline: {
                borderRadius: 0
            },
            input: {
                padding: 10
            }
        }
    }
});
